export interface IUserLoginRequest {
  userName: string
  password: string
  deviceRegistrationId?: string
}

export interface IUserLoginAutovitalsRequest {
  token: string
}
